import styled, { css, keyframes } from "styled-components";

const fadeInAnim = keyframes`
  0%{
     transform: translateY(75px);
     opacity:0
  }
  10%{
    transition-timing-function: cubic-bezier(0.42, 0, 0.07, 0.92);
    transform: translateY(75px);
    opacity:0
  }
  50%{
    transition-timing-function: cubic-bezier(0.29, 0.2, 0.62, 1);
    transform:translateY(-10px);
    opacity:0.5;
  }
  100%{
    transform:translateY(0px)
    opacity:1
   } 
`;

export const HistoryContainer = styled.div`
  animation: ${css`
    ${fadeInAnim} 550ms 1 forwards
  `};
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  background: #32075b;
  color: #6b66c7;
  display: flex;
  justify-content: center;
  align-items: center;

  th {
    padding: 16px 0;
    font-size: 10px;
  }
  thead {
    tr {
      width: 310px;
      display: grid;
      grid-template-columns: 30% 30% 40%;
    }
    th{
      text-align: left;
    }
    .thProfit {
      margin-left: 20px;
    }
  }

  tbody {
    tr {
      display: grid;
      grid-template-columns: 30% 30% 40%;
      svg {
        margin-bottom: -1px;
        path {
          fill: #6b66c7;
        }
      }
    }
  }
  /* .thUser {
     text-align:left
  }
  .thPayout {
     text-align:center

  }
  .thProfit {
    text-align:right
  } */
`;

export const HeaderD = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 320px;
  margin: auto;
  margin-bottom: 20px;
  div {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80px;
    height: 36px;
    border: solid 3px #6b66c7;
    border-radius: 18px;
  }

  svg {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    padding: 6px;
    border: solid 3px #6b66c7;
  }
`;

export const Tab = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px;
  border-radius: 18px;
  border: solid 3px #7f3da5;
  font-size: 16px;
  text-align: center;
  cursor: pointer;
  animation: ${(p) => (p.active ? "tab 50ms forwards 1 linear" : null)};

  .inner {
    position: absolute;
    top: -1px;
    left: -1px;
    height: 105%;
    width: 104%;
    background: #6b66c7;
    border-radius: 18px;
    opacity: 0;
    animation: ${(p) => (p.active ? "inner 167ms forwards 1 linear" : null)};
  }
  p {
    z-index: 1;
  }
  @keyframes inner {
    0% {
      transform: scale(0.5);
      opacity: 0;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
  @keyframes tab {
    0% {
      border-width: 3px;
      color: #6b66c7;
    }
    100% {
      border-width: 0px;
      color: #413f62;
    }
  }
`;

/*

   min-height: 125%;
  max-height: 603px;
  min-height: 100%;
  width: 100%;
  color: #6b66c7;
  padding: 90px 8% 8%;

  margin: auto;
  box-sizing: content-box;
  display: flex;
  flex-direction: column; */
/* max-width: 320px; */
/* min-height: 125%; */
// export const Tab = styled.div`
//   padding: 6px;
//   border-radius: 18px;
//   border: solid 3px #6b66c7;
//   font-size: 16px;
//   text-align: center;

//   animation: ${(p) => (p.active ? "tab 1s" : null)};

//   ${(p) =>
//     p.active
//       ? "background-color: #6b66c7 ; color:#413f62"
//       : "background-color: transparent"}
//   @keyframes tab {
//     0% {
//       opacity: 0;
//       transform: scale(0.5);
//     }
//     29% {
//       opacity: 1;
//       animation-timing-function: cubic-bezier(0.17, 0.17, 0.2, 1);
//     }
//     100% {
//       transform: scale(1);
//       animation-timing-function: cubic-bezier(0.35, 0, 0.2, 1);
//     }
//   }
// `;
